module.exports = __webpack_public_path__ + "static/media/pamain-light.36d37973.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/pamain-light.woff
// module id = ./src/assets/fonts/pamain-light.woff
// module chunks = 0